import capitalize from './filters/capitalize'
import money from './filters/money'

export default {
  install (Vue) {
    Vue.filter('capitalize', capitalize)
    Vue.filter('money', money)
  }
}



// WEBPACK FOOTER //
// ./src/global-filters.js